import type React from "react";
import { useEffect, useRef } from "react";
import LoadingSpinner from "../components/ui/loading-spinner";
import { useAuthStore } from "../stores/auth";

/**
 * AuthProvider - アプリケーション全体の認証状態を管理
 *
 * アプリケーション起動時に1回だけcheckAuth()を実行し、
 * 各Routeガードでの重複API呼び出しを防ぎます。
 *
 * これにより以下の効果があります:
 * - API呼び出しがアプリ起動時1回のみ（ページ遷移毎ではない）
 * - レース条件の解消（複数コンポーネントからの同時呼び出しを防ぐ）
 * - パフォーマンス向上
 */
export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { checkAuth, isReady } = useAuthStore();
  const hasChecked = useRef(false);

  useEffect(() => {
    // 初回マウント時のみ認証チェックを実行
    if (!hasChecked.current) {
      hasChecked.current = true;
      checkAuth();
    }
  }, [checkAuth]);

  // 初回認証チェックが完了するまでローディングスピナーを表示
  // （register/login 中は isReady が変化しないので children が再 mount されない）
  if (!isReady) {
    return <LoadingSpinner />;
  }

  return <>{children}</>;
}
